export default __webpack_public_path__ + "static/media/rinaldo_bellomo.b7615fa6.jpg";